import AbstractRepository from '@services/repositories/AbstractRepository';
import Cache from '@services/Cache';

export default class SalesTeamRepository extends AbstractRepository {
    constructor() {
        super();
        this.setApiUrl('/api/user/list');
    }

    /**
     *
     * @param id
     * @returns {Promise<*>}
     */
    async getById(id) {
        return this.getAll().then((users) => {
            const user = users.find((u) => u.id === id);
            return user;
        });
    }

    async getAll() {
        if (Cache.get('users-list')) {
            return Cache.get('users-list');
        }

        return this.setPerPage(1000).run().then((res) => {
            Cache.set('users-list', res);
            return Cache.get('users-list');
        });
    }

    async getSellers() {
        if (Cache.get('users-sellers-list')) {
            return Cache.get('users-sellers-list');
        }

        return this.getAll().then((users) => {
            const sellers = users.filter((u) => u.is_seller_sht);
            Cache.set('users-sellers-list', sellers);
            return Cache.get('users-sellers-list');
        });
    }
}
